<template>
    <div class="dashboard">
        <div class="content">
            <el-row class="mb10">
                <el-col :span="1" class="text-center bold">
                    Дата:
                </el-col>
                <el-col :span="4">
                    <el-date-picker
                        v-model="daysRange"
                        type="daterange"
                        range-separator="по"
                        start-placeholder="дата"
                        end-placeholder="дата"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                        @change="getRating"
                    />
                </el-col>
                <el-col :span="1" class="text-center bold">
                    Офис:
                </el-col>
                <el-col :span="2">
                    <el-select
                        v-model="officeId"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        placeholder=""
                        size="mini"
                        @change="getRating"
                    >
                        <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>
                <el-col :span="3" class="text-center bold">
                    Показывать уволенных
                </el-col>
                <el-checkbox v-model="showFired" @change="getRating" />
            </el-row>
            <el-row v-loading="loading">
                <el-col>
                    <div class="table managers">
                        <div class="table-header">
                            <div class="table-row">
                                <div class="table-cell bold">
                                    <el-tooltip popper-class="table-header-hint" content="Рейтинг" effect="light" placement="top">
                                        <span>Рейтинг</span>
                                    </el-tooltip>
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'header'"
                                    class="table-cell bold"
                                >
                                    <el-tooltip popper-class="table-header-hint" :content="column.hint" effect="light" placement="top">
                                        <span>{{ column.title }}</span>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="table-body">
                            <div v-for="(manager, index) in managersData" :key="index" :class="['table-row', isFiredEmployerClass(manager.date_fired)]">
                                <div class="table-cell rating">
                                    {{ index + 1 }}
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'data'"
                                    :class="[column.cellClass, getShadowClass(manager, column.field)]"
                                    :style="getCellOuterStyle(manager, column.field, index + 1, managersData.length)"
                                >
                                    <div
                                        :style="getCellInnerStyle(manager, column.field, index + 1, managersData.length)"
                                    >
                                        <template v-if="column.field === 'dealsVsLeads'">
                                            <span
                                                :class="{ 'link' : manager.dealsAllCount }"
                                                @click="openGrid('deals', manager.dealsAllIds)"
                                            >
                                                {{ manager.dealsAllCount }}
                                            </span> /
                                            <span
                                                :class="{ 'link' : manager.leadsNotTargetCount }"
                                                @click="openGrid('leads', manager.leadsNotTargetIds)"
                                            >
                                                {{ manager.leadsNotTargetCount }}
                                            </span>
                                        </template>
                                        <template v-else-if="column.field === 'measurementVsRefuseBeforeMeteringVsTechRefuse'">
                                            <span
                                                :class="{ 'link' : manager.dealsWithMeasurementDateCount }"
                                                @click="openGrid('deals', manager.dealsWithMeasurementDateIds)"
                                            >
                                                {{ manager.dealsWithMeasurementDateCount }}
                                            </span> /
                                            <span
                                                :class="{ 'link' : manager.dealsWithMeasurementDateRefuseBeforeMeteringCount }"
                                                @click="openGrid('deals', manager.dealsWithMeasurementDateRefuseBeforeMeteringIds)"
                                            >
                                                {{ manager.dealsWithMeasurementDateRefuseBeforeMeteringCount }}
                                            </span> /
                                            <span
                                                :class="{ 'link' : manager.dealsWithMeasurementDateTechRefuseCount }"
                                                @click="openGrid('deals', manager.dealsWithMeasurementDateTechRefuseIds)"
                                            >
                                                {{ manager.dealsWithMeasurementDateTechRefuseCount }}
                                            </span>
                                        </template>
                                        <template v-else-if="column.field === 'dealsWithContractDateCount'">
                                            <span
                                                :class="{ 'link' : manager.dealsWithContractDateCount }"
                                                @click="openGrid('deals', manager.dealsWithContractDateIds)"
                                            >
                                                {{ manager.dealsWithContractDateCount }}
                                            </span>
                                        </template>
                                        <template v-else-if="column.field === 'dealsWithClosedStatusCount'">
                                            <span
                                                :class="{ 'link' : manager.dealsWithClosedStatusCount }"
                                                @click="openGrid('deals', manager.dealsWithClosedStatusIds)"
                                            >
                                                {{ manager.dealsWithClosedStatusCount }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            {{ manager[column.field] }}
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-row-empty"></div>
                        <div class="table-footer">
                            <div class="table-row">
                                <div class="table-cell relative hide-border">
                                    <div class="table-label-total">
                                        ИТОГО:
                                    </div>
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'total'"
                                    class="table-cell"
                                    :class="[
                                        {'hide-border': column.field === 'office'},
                                        {'hide-text': column.field === 'office'},
                                        {'implementation': column.field === 'implementation'}
                                    ]"
                                    :style="getTotalCellOuterStyle(totalData, column.field)"
                                >
                                    <div
                                        :style="getTotalCellInnerStyle(totalData, column.field)"
                                    >
                                        {{ totalData[column.field] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import employersRating from '@/mixins/employersRating';

export default {
    name: 'ManagersRating',
    mixins: [
        employersRating
    ],
    data() {
        return {
            showFired: 0,
            columns: [
                {
                    field: 'office',
                    title: 'Офис',
                    hint: 'Офис',
                    cellClass: 'table-cell text-left'
                },
                {
                    field: 'manager',
                    title: 'Менеджер',
                    hint: 'Менеджер',
                    cellClass: 'table-cell text-left'
                },
                {
                    field: 'sales',
                    title: 'Сумма продаж',
                    hint: 'Бюджет договора, заключенного в период минус договора в статусе "Договор фиксация"',
                    cellClass: 'table-cell substrate'
                },
                {
                    field: 'plan',
                    title: 'План',
                    hint: 'План',
                    cellClass: 'table-cell'
                },
                {
                    field: 'implementation',
                    title: 'Выполнение %',
                    hint: 'Сумма продаж/план',
                    cellClass: 'table-cell substrate'
                },
                {
                    field: 'dealsVsLeads',
                    title: 'Кол-во сделок / не целевых',
                    hint: 'кол-во созданных сделок в период фильтра/кол-во лидов "не целевой" с датой создания лида в период',
                    cellClass: 'table-cell'
                },
                {
                    field: 'measurementVsRefuseBeforeMeteringVsTechRefuse',
                    title: 'Кол-во замеров / ОДЗ / Техотказ',
                    hint: 'кол-во сделок с датой замера в период И без галки ОДЗ И Техотказ ' +
                        '/ кол-во сделок с датой замера в период И с галкой ОДЗ / кол-во сделок с датой замера в период И с галкой Техотказ',
                    cellClass: 'table-cell'
                },
                {
                    field: 'dealsWithContractDateCount',
                    title: 'Кол-во договоров',
                    hint: 'кол-во сделок с датой договора в период',
                    cellClass: 'table-cell'
                },
                {
                    field: 'dealsWithClosedStatusCount',
                    title: 'Кол-во отказов',
                    hint: 'кол-во сделок с датой установки статуса "Закрыто и нереализовано"',
                    cellClass: 'table-cell'
                },
                {
                    field: 'square',
                    title: 'м2',
                    hint: 'сделки с датой договора в период - сумма "Квадратура"',
                    cellClass: 'table-cell'
                },
                {
                    field: 'squarePrice',
                    title: 'Цена м2',
                    hint: 'Сумма продаж/м2',
                    cellClass: 'table-cell'
                },
                {
                    field: 'discountPercent',
                    title: 'Скидка %',
                    hint: 'сумма всех скидок(скидки в процентах) В РУБЛЯХ по сделкам с датой договора в период / сумма продаж',
                    cellClass: 'table-cell'
                },
                {
                    field: 'contactByMeasurement',
                    title: 'Обращение/замер %',
                    hint: 'кол-во замеров без ОДЗ И Техотказ/кол-во сделок',
                    cellClass: 'table-cell'
                },
                {
                    field: 'measurementByContract',
                    title: 'Замер/Договор %',
                    hint: 'кол-во замеров без ОДЗ и Техотказ / кол-во договоров',
                    cellClass: 'table-cell'
                },
                {
                    field: 'contactByContract',
                    title: 'Конверсия (Обр./Договор) %',
                    hint: 'кол-во договоров/кол-во сделок',
                    cellClass: 'table-cell'
                }
            ]
        };
    },
    computed: {
        officeList() {
            return this.$store.state.references.offices;
        },
        managersData() {
            return this.$store.state.analytics.managers;
        },
        totalData() {
            return this.$store.state.analytics.managersTotal;
        }
    },
    methods: {
        async getRating() {
            try {
                this.loading = true;
                await this.$store.dispatch('analytics/getManagersRating', {
                    startDay: this.daysRange[0],
                    endDay: this.daysRange[1],
                    officeId: this.officeId,
                    showFired: +this.showFired
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
